(function () {
  'use strict';

  var BADGES = ['A', 'B', 'C', 'D'];
  var OPTION_KEYS = ['a', 'b', 'c', 'd'];

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getRank(correct, total, ranks) {
    var pct = total ? (correct / total) * 100 : 0;
    var list = ranks && ranks.length ? ranks : [
      { min: 100, title: 'Head Boy / Head Girl', blurb: 'Flawless. Dumbledore would be proud.' },
      { min: 87, title: 'Outstanding', blurb: 'A true scholar of the Wizarding World.' },
      { min: 74, title: 'Exceeds Expectations', blurb: 'Solid knowledge — a worthy witch or wizard.' },
      { min: 57, title: 'Acceptable', blurb: 'Not bad — a few more trips to the library might help.' },
      { min: 0, title: 'Troll', blurb: 'Even a first-year knows more than this. Study up!' }
    ];

    for (var i = 0; i < list.length; i++) {
      if (pct >= list[i].min) return list[i];
    }
    return list[list.length - 1];
  }

  function initParticles(container, count) {
    if (!container || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var colors = ['#CA9E48', '#F9E78D', '#ffffff', '#a9874a'];
    for (var i = 0; i < count; i++) {
      var el = document.createElement('div');
      var size = 2 + Math.random() * 3;
      var left = Math.random() * 100;
      var delay = Math.random() * 8;
      var duration = 10 + Math.random() * 14;
      var drift = (Math.random() - 0.5) * 80;

      el.style.cssText =
        'position:absolute;width:' + size + 'px;height:' + size + 'px;' +
        'left:' + left + '%;bottom:-20px;border-radius:50%;' +
        'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
        'opacity:0;--drift:' + drift + 'px;' +
        'animation:qFloat ' + duration + 's linear ' + delay + 's infinite;';

      container.appendChild(el);
    }
  }

  function launchConfetti(container, count) {
    if (!container || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    container.innerHTML = '';
    var colors = ['#CA9E48', '#F9E78D', '#ffffff', '#81c784', '#ef9a9a', '#a9874a'];
    var total = count || 48;

    for (var i = 0; i < total; i++) {
      var piece = document.createElement('div');
      var w = 4 + Math.random() * 6;
      var h = 4 + Math.random() * 10;
      var left = Math.random() * 100;
      var delay = Math.random() * 0.8;
      var duration = 2.5 + Math.random() * 2;

      piece.style.cssText =
        'position:absolute;left:' + left + '%;top:-20px;width:' + w + 'px;height:' + h + 'px;' +
        'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
        'opacity:0.9;animation:confetti ' + duration + 's ease-in ' + delay + 's forwards;';

      container.appendChild(piece);
    }

    window.setTimeout(function () {
      container.innerHTML = '';
    }, 5000);
  }

  function trackKlaviyoQuizComplete(quizName) {
    window.klaviyo = window.klaviyo || [];
    var email = '';
    try { email = sessionStorage.getItem('kl_quiz_email') || ''; } catch (e) {}
    if (email) klaviyo.push(['identify', { '$email': email }]);
    klaviyo.push(['track', 'Completed Quiz', {
      "Quiz": "Ecoy Raffle Quiz",
      "Page": window.location.pathname
    }]);
  }

  function buildFlatQuestions(sections) {
    var flat = [];
    sections.forEach(function (section, sIdx) {
      section.questions.forEach(function (q, qIdx) {
        flat.push({
          sectionIndex: sIdx,
          questionIndex: qIdx,
          section: section,
          question: q
        });
      });
    });
    return flat;
  }

  function HpQuiz(root, config) {
    this.root = root;
    this.config = config;
    this.sections = config.sections || [];
    this.flat = buildFlatQuestions(this.sections);
    this.totalQuestions = this.flat.length;

    this.screen = 'start';
    this.sectionIndex = 0;
    this.questionFlatIndex = 0;
    this.answered = false;
    this.selectedKey = null;
    this.correctCount = 0;
    this.entryNo = config.entryNo || this.generateEntryNo();
    this._klaviyoCompleted = false;

    this.cacheDom();
    this.mountConfetti();
    this.bindEvents();
    initParticles(this.particlesEl, config.particleCount || 18);
    this.render();
  }

  HpQuiz.prototype.formatEntryNo = function (value) {
    var storage = window.HpEntryStorage;
    if (storage) return storage.formatEntryDigits(value) || String(value || '');
    return String(value || '');
  };

  HpQuiz.prototype.generateEntryNo = function () {
    var storage = window.HpEntryStorage;
    if (storage) return storage.assignEntry(false);
    return String(Math.min(999999, Date.now() % 999999) || 1);
  };

  HpQuiz.prototype.mountConfetti = function () {
    if (!this.confettiEl || this.confettiEl.dataset.qzMounted) return;
    document.body.appendChild(this.confettiEl);
    this.confettiEl.dataset.qzMounted = '1';
  };

  HpQuiz.prototype.cacheDom = function () {
    this.progressBar = this.root.querySelector('[data-qz-progress-bar]');
    this.screenEl = this.root.querySelector('[data-qz-screen]');
    this.confettiEl = this.root.querySelector('[data-qz-confetti]');
    this.particlesEl = this.root.querySelector('[data-qz-particles]');
    this.quizListEl = this.root.querySelector('[data-qz-quiz-list]');
    this.entryEls = this.root.querySelectorAll('[data-qz-entry]');
  };

  HpQuiz.prototype.bindEvents = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qz-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-qz-action');
      if (action === 'begin') self.begin();
      if (action === 'section-begin') self.beginSection();
      if (action === 'continue') self.continueFlow();
      if (action === 'restart') self.restart();
      if (action === 'shop') {
        var url = self.config.shopUrl;
        if (url) window.location.href = url;
      }
    });

    this.root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-qz-option]');
      if (!opt || self.answered) return;
      self.selectOption(opt.getAttribute('data-qz-option'));
    });
  };

  HpQuiz.prototype.begin = function () {
    this.sectionIndex = 0;
    this.questionFlatIndex = 0;
    this.correctCount = 0;
    this.screen = 'section';
    this.render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  HpQuiz.prototype.beginSection = function () {
    this.screen = 'question';
    this.answered = false;
    this.selectedKey = null;
    this.render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  HpQuiz.prototype.getCurrentFlat = function () {
    return this.flat[this.questionFlatIndex] || null;
  };

  HpQuiz.prototype.selectOption = function (key) {
    var current = this.getCurrentFlat();
    if (!current || this.answered) return;

    this.answered = true;
    this.selectedKey = key;
    var isCorrect = key === current.question.correct;
    if (isCorrect) this.correctCount += 1;
    this.render();
    if (isCorrect) launchConfetti(this.confettiEl, 32);
  };

  HpQuiz.prototype.continueFlow = function () {
    var current = this.getCurrentFlat();
    if (!current) return;

    var nextFlatIndex = this.questionFlatIndex + 1;
    if (nextFlatIndex >= this.flat.length) {
      this.screen = 'result';
      this.render();
      launchConfetti(this.confettiEl, 56);
      if (!this._klaviyoCompleted) {
        this._klaviyoCompleted = true;
        trackKlaviyoQuizComplete(this.config.klaviyoQuizName);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var nextItem = this.flat[nextFlatIndex];
    if (nextItem.sectionIndex !== current.sectionIndex) {
      this.sectionIndex = nextItem.sectionIndex;
      this.questionFlatIndex = nextFlatIndex;
      this.screen = 'section';
    } else {
      this.questionFlatIndex = nextFlatIndex;
      this.screen = 'question';
    }

    this.answered = false;
    this.selectedKey = null;
    this.render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  HpQuiz.prototype.restart = function () {
    this.screen = 'start';
    this.sectionIndex = 0;
    this.questionFlatIndex = 0;
    this.answered = false;
    this.selectedKey = null;
    this.correctCount = 0;
    this._klaviyoCompleted = false;
    if (this.confettiEl) this.confettiEl.innerHTML = '';
    this.render();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  HpQuiz.prototype.getProgress = function () {
    if (this.screen === 'start') return 0;
    if (this.screen === 'result') return 100;
    return Math.round((this.questionFlatIndex / Math.max(this.totalQuestions, 1)) * 100);
  };

  HpQuiz.prototype.renderQuizList = function () {
    if (!this.quizListEl) return;
    var html = '';
    this.sections.forEach(function (section) {
      html +=
        '<div class="hp-quiz__quiz-item">' +
          '<span class="hp-quiz__quiz-num">' + escapeHtml(section.roman) + '</span>' +
          '<div>' +
            '<div class="hp-quiz__quiz-item-title">' + escapeHtml(section.title) + '</div>' +
            '<div class="hp-quiz__quiz-item-sub">' + escapeHtml(section.subtitle) + '</div>' +
          '</div>' +
        '</div>';
    });
    this.quizListEl.innerHTML = html;
  };

  HpQuiz.prototype.renderStart = function () {
    var c = this.config;
    return (
      '<div class="hp-quiz__panel hp-quiz__start">' +
        '<div class="hp-quiz__eyebrow">' + escapeHtml(c.startEyebrow) + '</div>' +
        '<div class="hp-quiz__owl" aria-hidden="true">' + escapeHtml(c.owlEmoji || '🦉') + '</div>' +
        '<h1 class="hp-quiz__start-title">' + c.startHeading + '</h1>' +
        '<p class="hp-quiz__start-body">' + c.startBody + '</p>' +
        '<div class="hp-quiz__quiz-list" data-qz-quiz-list></div>' +
        '<button type="button" class="hp-quiz__btn" data-qz-action="begin">' + escapeHtml(c.beginButton) + '</button>' +
        '<p class="hp-quiz__footnote">' + escapeHtml(c.startFootnote) + '</p>' +
      '</div>'
    );
  };

  HpQuiz.prototype.renderSection = function () {
    var section = this.sections[this.sectionIndex];
    if (!section) return '';

    var count = section.questions.length;
    return (
      '<div class="hp-quiz__panel hp-quiz__section-intro">' +
        '<div class="hp-quiz__section-ring" aria-hidden="true">' +
          '<span></span><span></span><span></span>' +
          '<span class="hp-quiz__section-roman">' + escapeHtml(section.roman) + '</span>' +
        '</div>' +
        '<div class="hp-quiz__section-kicker">Quiz ' + escapeHtml(section.roman) + ' · ' + count + ' questions</div>' +
        '<h2 class="hp-quiz__section-title">' + escapeHtml(section.title) + '</h2>' +
        '<p class="hp-quiz__section-sub">' + escapeHtml(section.subtitle) + '</p>' +
        '<button type="button" class="hp-quiz__btn" data-qz-action="section-begin">' + escapeHtml(this.config.sectionButton) + '</button>' +
      '</div>'
    );
  };

  HpQuiz.prototype.renderQuestion = function () {
    var current = this.getCurrentFlat();
    if (!current) return '';

    var section = current.section;
    var q = current.question;
    var qNum = current.questionIndex + 1;
    var qTotal = section.questions.length;
    var correctKey = q.correct;
    var isCorrect = this.selectedKey === correctKey;

    var optionsHtml = '';
    OPTION_KEYS.forEach(function (key, idx) {
      var text = q.options[key];
      if (!text) return;

      var classes = 'hp-quiz__option';
      var mark = '';

      if (this.answered) {
        if (key === correctKey) {
          classes += ' hp-quiz__option--correct';
          mark = '✓';
        } else if (key === this.selectedKey) {
          classes += ' hp-quiz__option--wrong';
          mark = '✗';
        }
      }

      optionsHtml +=
        '<button type="button" class="' + classes + '" data-qz-option="' + key + '"' +
          (this.answered ? ' disabled' : '') + '>' +
          '<span class="hp-quiz__option-badge">' + BADGES[idx] + '</span>' +
          '<span class="hp-quiz__option-text">' + escapeHtml(text) + '</span>' +
          '<span class="hp-quiz__option-mark" aria-hidden="true">' + mark + '</span>' +
        '</button>';
    }, this);

    var explainHtml = '';
    if (this.answered) {
      var verdictClass = isCorrect ? 'hp-quiz__explain-verdict--correct' : 'hp-quiz__explain-verdict--wrong';
      var verdict = isCorrect ? this.config.correctLabel : this.config.wrongLabel;
      var continueLabel = this.questionFlatIndex + 1 >= this.flat.length
        ? this.config.finishButton
        : this.config.continueButton;

      explainHtml =
        '<div class="hp-quiz__explain">' +
          '<div class="hp-quiz__explain-verdict ' + verdictClass + '">' + escapeHtml(verdict) + '</div>' +
          '<div class="hp-quiz__explain-text">' + escapeHtml(q.explanation) + '</div>' +
        '</div>' +
        '<button type="button" class="hp-quiz__btn hp-quiz__continue" data-qz-action="continue">' +
          escapeHtml(continueLabel) +
        '</button>';
    }

    return (
      '<div class="hp-quiz__panel hp-quiz__question-wrap">' +
        '<div class="hp-quiz__card">' +
          '<div class="hp-quiz__card-head">' +
            '<span class="hp-quiz__card-chip">Quiz ' + escapeHtml(section.roman) + ' · ' + escapeHtml(section.title) + '</span>' +
            '<span class="hp-quiz__card-num">Q' + qNum + ' of ' + qTotal + '</span>' +
          '</div>' +
          '<h2 class="hp-quiz__question-text">' + escapeHtml(q.text) + '</h2>' +
          '<div class="hp-quiz__options">' + optionsHtml + '</div>' +
          explainHtml +
        '</div>' +
      '</div>'
    );
  };

  HpQuiz.prototype.renderResult = function () {
    var c = this.config;
    var rank = getRank(this.correctCount, this.totalQuestions, c.ranks);
    var email = c.email || 'your inbox';

    return (
      '<div class="hp-quiz__panel hp-quiz__result">' +
        '<div class="hp-quiz__eyebrow">' + escapeHtml(c.resultEyebrow) + '</div>' +
        '<div class="hp-quiz__owl" aria-hidden="true">' + escapeHtml(c.owlEmoji || '🦉') + '</div>' +
        '<h1 class="hp-quiz__result-title">' + c.resultHeading + '</h1>' +
        '<div class="hp-quiz__score-ring">' +
          '<div class="hp-quiz__score-ring-outer"></div>' +
          '<div class="hp-quiz__score-inner">' +
            '<div class="hp-quiz__score-num">' + this.correctCount + '</div>' +
            '<div class="hp-quiz__score-label">out of ' + this.totalQuestions + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="hp-quiz__rank-title">' + escapeHtml(rank.title) + '</div>' +
        '<p class="hp-quiz__rank-blurb">' + escapeHtml(rank.blurb) + '</p>' +
        '<div class="hp-quiz__result-card">' +
          '<div class="hp-quiz__result-row">' +
            '<div>' +
              '<div class="hp-quiz__result-kicker">' + escapeHtml(c.emailKicker) + '</div>' +
              '<div class="hp-quiz__result-copy">' + c.emailCopy.replace('[email]', '<b>' + escapeHtml(email) + '</b>') + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="hp-quiz__result-divider"></div>' +
          '<div class="hp-quiz__result-row">' +
            '<span class="hp-quiz__result-icon" aria-hidden="true">♛</span>' +
            '<div>' +
              '<div class="hp-quiz__result-kicker">' + escapeHtml(c.raffleKicker) + '</div>' +
              '<div class="hp-quiz__result-copy">' +
                c.raffleCopy
                  .replace('[entry]', '<b>' + escapeHtml(this.formatEntryNo(this.entryNo)) + '</b>')
                  .replace('[prize]', '<b>' + escapeHtml(c.prizeUnit) + '</b>') +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="hp-quiz__btn" data-qz-action="restart">' + escapeHtml(c.restartButton) + '</button>' +
        (c.shopUrl
          ? '<button type="button" class="hp-quiz__btn hp-quiz__btn--ghost" data-qz-action="shop">' + escapeHtml(c.shopButton) + '</button>'
          : '') +
        '<p class="hp-quiz__result-summary">' +
          escapeHtml(c.resultSummary
            .replace('[correct]', String(this.correctCount))
            .replace('[total]', String(this.totalQuestions))) +
        '</p>' +
      '</div>'
    );
  };

  HpQuiz.prototype.render = function () {
    var html = '';
    if (this.screen === 'start') html = this.renderStart();
    else if (this.screen === 'section') html = this.renderSection();
    else if (this.screen === 'question') html = this.renderQuestion();
    else if (this.screen === 'result') html = this.renderResult();

    if (this.screenEl) this.screenEl.innerHTML = html;
    if (this.progressBar) this.progressBar.style.width = this.getProgress() + '%';

    this.entryEls = this.root.querySelectorAll('[data-qz-entry]');
    for (var i = 0; i < this.entryEls.length; i++) {
      this.entryEls[i].textContent = this.formatEntryNo(this.entryNo);
    }

    if (this.screen === 'start') {
      this.quizListEl = this.root.querySelector('[data-qz-quiz-list]');
      this.renderQuizList();
    }
  };

  function parseConfig(scriptEl) {
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('HP Quiz: invalid config JSON', e);
      return null;
    }
  }

  function init() {
    document.querySelectorAll('[data-hp-quiz]').forEach(function (root) {
      if (root.dataset.qzReady) return;
      var script = root.querySelector('[data-qz-config]');
      var config = parseConfig(script);
      if (!config) return;
      root.dataset.qzReady = '1';
      new HpQuiz(root, config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
